// extracted by mini-css-extract-plugin
module.exports = {"appTitle":"AppTitle_appTitle__3A4a8"};